<script>
  import { birthData } from "../stores/birthData.js";
  import { astroData } from "../stores/astroData.js";
  import Navigation from "./Navigation.svelte";
  import Details from "./Details.svelte";
  import { pGlyph, sGlyph, aGlyph } from '../stores/glyph.js';
  import { padding, makeReadable, decodeHtml } from '../utils/utils.js';

  // Use the $ sign to create reactive variables
  $: name = $birthData.name;
  /*
  $: date = $birthData.date;
  $: time = $birthData.time;
  $: location = $birthData.location;
  $: tzName = $birthData.tzName;
  $: longitude = $birthData.longitude;
  $: latitude = $birthData.latitude;
  */
  $: planeten = $astroData.planets;
  $: huizen = $astroData.houses;
/*
  // Add leading zero to single digit numbers
  function padding(number) {
    return number.toString().padStart(2, "0");
  }
*/
/*
  function decimalToDMS(decimal) {
    const degrees = Math.floor(decimal);
    const minutes = Math.floor((decimal - degrees) * 60);
    const seconds = Math.round((decimal - degrees - minutes / 60) * 3600);
    const paddedDegrees = degrees.toString().padStart(3, "0");
    const paddedMinutes = minutes.toString().padStart(2, "0");
    const paddedSeconds = seconds.toString().padStart(2, "0");
    return `${paddedDegrees}° ${paddedMinutes}' ${paddedSeconds}"`;
  }
  */
/* // zijn naar details gegaan..
  function readableLatitude() {
    const hemisphere = latitude >= 0 ? "N" : "S";
    return `${decimalToDMS(Math.abs(latitude))} ${hemisphere}`;
  }

  function readableLongitude() {
    const hemisphere = longitude >= 0 ? "E" : "W";
    return `${decimalToDMS(Math.abs(longitude))} ${hemisphere}`;
  }
*/
  function formatDegree(decimalDegree) {
    // Convert decimal degrees to degrees, minutes, and seconds
    let degree = Math.floor(decimalDegree);
    const minute = Math.floor((decimalDegree - degree) * 60);
    const second = Math.round(((decimalDegree - degree) * 60 - minute) * 60);

    const zodiacSigns = [
      "Aries",
      "Taurus",
      "Gemini",
      "Cancer",
      "Leo",
      "Virgo",
      "Libra",
      "Scorpio",
      "Sagittarius",
      "Capricorn",
      "Aquarius",
      "Pisces",
    ];

    const zodiacIndex = Math.floor(decimalDegree / 30);
    const zodiacSign = zodiacSigns[zodiacIndex];
    degree = degree - zodiacIndex * 30;
    return `${padding(degree)}°${padding(minute)}'${padding(
      second
    )}'' ${zodiacSign}`;
  }

  function planetInHouse(houses, planets) {
    const plhuis = [];
    for (let p = 0; p < planets.length; p++) {
      for (let i = 0; i < houses.length; i++) {
        let a = parseFloat(houses[i]["long"]);
        let b = parseFloat(houses[(i + 1) % houses.length]["long"]);
        if (a <= b) {
          if (planets[p]["pos"] >= a - 3 && planets[p]["pos"] < b - 3) {
            plhuis[p] = i + 1;
            break;
          }
        } else {
          if (planets[p]["pos"] >= a - 3 && planets[p]["pos"] < b - 3 + 360) {
            plhuis[p] = i + 1;
            break;
          } else if (planets[p]["pos"] < a - 3 && planets[p]["pos"] < b - 3) {
            plhuis[p] = i + 1;
            break;
          }
        }
      }
    }
    return plhuis;
  }
  // Use a ternary operator instead of an if-else block to simplify the isLoading/hasData check
  $: isLoading = planeten.length === 0 && huizen.length === 0;
  $: hasData = planeten.length > 0 || huizen.length > 0;

  let inHouse = [];
  // if hasData is true run the planetInHouse function
  $: if (hasData) {
    inHouse = planetInHouse(huizen, planeten);
    document.title = `Horoscoop van ${name}`;
  }

  // Use a computed property to simplify the isRetrograde() function
  const isRetrograde = (speed) => (speed < 0 ? "&#118;" : "");

  function imageSource(planeten, huizen, inHouse) {
    let L1 = planeten.map((pll) => pll.pos);
    let rx1 = "";
    planeten.forEach((pll) => {
      if (pll.snel < 0) rx1 += "r";
      else rx1 += " ";
    });
    let hc1 = [];
    for (let x = 1; x <= 12; x++) {
      hc1[x] = huizen[x - 1].long;
    }
    rx1 = encodeURIComponent(rx1);
    let ser_L1 = JSON.stringify(L1);
    let ser_hc1 = JSON.stringify(hc1);
    let ser_inhuis = JSON.stringify(inHouse);

    let imgSrc = `https://astro.astrosofica.nl/php/natal_wheel.php?rx1=${rx1}&p1=${ser_L1}&hc1=${ser_hc1}&hpos=${ser_inhuis}`;
    return imgSrc;
  }
</script>

<div class="container">
 <Navigation />
 <Details />
 <h4 class="noshow">&nbsp;</h4>
  {#if isLoading}
    <p>Standen worden berekend....</p>
  {:else if hasData}
    <div class="duotable-container">
      <table class="duotable1">
        <thead>
          <tr>
            <th colspan="2">Huizen Koch</th>
          </tr>
        </thead>
        <tbody>
          {#each huizen as huis}
            <tr class="table-row">
              <td><span class="desktop">Cusp </span><span class="mobile">H</span>{huis.house}</td>
              <td>{@html makeReadable(huis.long, sGlyph)}</td>
            </tr>
          {/each}
        </tbody>
      </table>
      <table class="duotable2">
        <thead>
          <tr>
            <th colspan="3">Planeten</th>
          </tr>
        </thead>
        <tbody>
          {#each planeten as planet, i}
            {#if i <= 10}
            <tr class="table-row">
              <td class="astro-font">{@html pGlyph[i]}</td>
              <td>{@html makeReadable(planet.pos, sGlyph)} <span class="astro-font">{@html isRetrograde(planet.snel)}</span></td>
              <td><span class="desktop">staat in huis </span><span class="mobile">H</span>{inHouse[i]}</td>
            </tr>
            {/if}
          {/each}
        </tbody>
      </table>
    </div>
    <img
      border="0"
      alt="chart"
      src={imageSource(planeten, huizen, inHouse)}
      width="600"
      height="600"
      class="chart"
    />
  {:else}
    <p>No data available.</p>
  {/if}
</div>

<style>
  .duotable-container {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
  }
  .duotable1 {
    flex: 1 0 40%;
    box-sizing: border-box;
  }
  .duotable2 {
    flex: 1 0 60%;
    box-sizing: border-box;
  }
  .noshow {
    font-size: xx-small;
    margin: 2px;
  }
  .chart {
    max-width: 100%;
    height: auto;
  }

  @media screen and (max-width: 350px) {
      /* 768px is a common breakpoint for tablets and below. Adjust as needed. */
      .duotable1, .duotable2 {
        flex: 1 0 100%;
      }
    }

  @media (max-width: 500px) {
    .desktop {
      display: none;
    }
  }
  @media (min-width: 500px) {
    .mobile {
      display: none;
    }
  }

</style>
